import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.243 4.26932L17.6251 3.2894C16.6978 2.72773 15.4923 3.00769 14.9067 3.92069L11.998 8.45599L9.09157 3.92164C8.50608 3.00821 7.30014 2.7281 6.37263 3.29008L4.71196 4.29708C3.78229 4.89417 3.5122 6.1326 4.10869 7.0632L6.91489 11.4404C6.02931 12.5522 5.50002 13.9609 5.50002 15.4935C5.50002 19.0869 8.41017 22 12 22C15.5899 22 18.5 19.0869 18.5 15.4935C18.5 13.9605 17.9704 12.5513 17.0844 11.4394L19.8907 7.06357L19.998 6.87468C20.4587 5.95117 20.1408 4.8131 19.243 4.26932ZM6.50002 15.4935C6.50002 12.4528 8.96246 9.98792 12 9.98792C15.0376 9.98792 17.5 12.4528 17.5 15.4935C17.5 18.5341 15.0376 20.999 12 20.999C8.96246 20.999 6.50002 18.5341 6.50002 15.4935ZM6.88516 4.11927L5.25328 5.10845C4.81461 5.37436 4.65302 5.92407 4.86123 6.37986L4.92953 6.50513L7.61253 10.6918C8.58214 9.80335 9.82175 9.20538 11.1939 9.03548L8.24483 4.43499C7.95206 3.97818 7.34895 3.83814 6.88516 4.11927ZM12.8037 9.03517L15.7536 4.43465C16.0464 3.97799 16.6493 3.83798 17.1131 4.11897L18.7459 5.10841L18.8626 5.19095C19.25 5.50846 19.3467 6.07324 19.0697 6.5053L16.3868 10.6912C15.4168 9.80254 14.1765 9.20462 12.8037 9.03517Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'award');
export default IconComponent;
